export default "__VITE_ASSET__98897f3b__"